// 销售状态部分1
window.ProductSalesStatus = new window.ProductSalesStatus();

/**
 * 更新paypal支付
 **/
function updatePaypal(params) {
  paypal
    .Messages({
      amount: params,
      style: {
        layout: "text",
        logo: {
          type: "primary",
        },
        text: {
          color: "black",
          size: 14,
        },
      },
    })
    .render("#is-paypal");

  //   paypal.Buttons({
  //     createOrder: function(data, actions) {
  //         return actions.order.create({
  //           purchase_units: [{
  //             amount: {
  //               value: params
  //             }
  //           }]
  //         });
  //       }
  // }).render('#paypal-button-container');
}

(() => {
  class t extends HTMLElement {
    constructor() {
      super();
      this.main = this.closest("main-product");
      this.isLogin = Boolean(this.main.getAttribute('data-is-login'));
      this.memberPriceList = JSON.parse(this.main.getAttribute('data-member-price'));
      this.addEventListener("change", this.onVariantChange);
      this.updateCode();
      this.initProductDiscounts();
      this.modalDiscounts();
    }
    modalDiscounts() {
      UIkit.util.on(
        "#modal-product-discounts",
        "show",
        function () {
          var modalDiscountedPriceEl = document.querySelector(
            "[data-modal-discounted-price]"
          );
          var modalRebatesPriceEl = document.querySelector(
            "[data-modal-rebates-price]"
          );

          var modalRebatesImgEl = document.querySelector(
            "[data-modal-discounted-img]"
          );
          var modalRebatesTitleEl = document.querySelector(
            "[data-modal-discounted-title]"
          );
          let currentVariant = this.currentVariant;
          let price = this.main.dataset.price;
          let title = this.main.dataset.title;
          let img = this.main.dataset.img;
          if (currentVariant) {
            price = currentVariant.price;
            title = currentVariant.title;
            img = currentVariant.featured_image.src;
          }
          let obj = this.discountedPriceF(price);
          modalDiscountedPriceEl.textContent = obj.discountedPrice;
          modalRebatesPriceEl.textContent = obj.rebatesPrice;
          modalRebatesTitleEl.textContent = title;
          modalRebatesImgEl.setAttribute("src", img);
        }.bind(this)
      );
    }
    initProductDiscounts() {
      var price = this.main.dataset.price;
      this.updateProductDiscounts(price);
    }
    updateProductDiscounts(price) {
      var discountedPriceEl = this.main.querySelector(
        "[data-discounted-price]"
      );
      var rebatesPriceEl = this.main.querySelector("[data-rebates-price]");
      if (!discountedPriceEl || !rebatesPriceEl) return;
      let obj = this.discountedPriceF(price);
      // 回扣价格
      discountedPriceEl.textContent = obj.discountedPrice;
      rebatesPriceEl.textContent = obj.rebatesPrice;
    }
    discountedPriceF(price) {
      // 优惠30%后的价格
      var discountedPrice = (price * 0.7) / 100;
      // 判断小数部分是否大于0
      if (discountedPrice % 1 > 0) {
        // 保留2位小数
        discountedPrice = Math.floor(discountedPrice * 100) / 100;
      } else {
        // 如果小数部分为0，则直接取整
        discountedPrice = Math.floor(discountedPrice);
      }
      // 判断小数部分是否大于0
      var rebatesPrice = (price * 0.3) / 100;

      // 回扣价格
      if (discountedPrice % 1 > 0) {
        // 保留2位小数
        rebatesPrice = Math.floor(rebatesPrice * 100) / 100;
      } else {
        // 如果小数部分为0，则直接取整
        rebatesPrice = Math.floor(rebatesPrice);
      }

      let obj = {
        rebatesPrice: ` $${rebatesPrice.toLocaleString()} `,
        discountedPrice: ` $${discountedPrice.toLocaleString()} `,
      };
      return obj;
    }
    // 更新会员价格
    updateProductPrice(){
      if(this.main.querySelector(".text-wrapper")){
          var list = this.currentVariant;
          var info =  this.memberPriceList.filter((item) => { return item.id === list.id});
          if(this.isLogin && info && info[0].price){
            this.main.querySelector(".text-wrapper").innerHTML ="Members Only";
          }else{
            this.main.querySelector(".text-wrapper").innerHTML ="Purchase for";
          } 
      }

    }
    onVariantChange() {
      this.updateOptions(),
        this.updateMasterId(),
        this.updateSelectInfo(),
        this.toggleAddButton(!0, "", !1),
        this.removeErrorMessage(),
        this.currentVariant
          ? (
            // 销售状态部分2
            window.ProductSalesStatus.updateStatus(this.currentVariant.id, this.currentVariant),
            this.updateMedia(),
            this.updateURL(),
            this.updateVariantInput(),
            this.renderProductInfo()
          )
          : (this.toggleAddButton(!0, "", !0), this.setUnavailable());
      this.updateCode();
      this.updatePay();
      this.updateCheckout();
      this.updateProductPrice();
      // document.querySelector(".affirm-as-low-as") ? this.updatePay() : '';
    }
        // 更新立即结账变体ID
    updateCheckout(){
     var currentVariant = this.currentVariant;
     this.main.querySelector(".tm-to-checkout").dataset.id = currentVariant.id; 
    }
    // 更新affirm分期支付
    updatePay() {
      const currentVariant = this.currentVariant;
      const sku = currentVariant.sku;
      const list = [
        "AC500+B300S-SPFUS",
        "AC500+2*B300S-SPFUS",
        "2*AC500+4*B300S-SPFUS",
        "AC500-US-GY-BL-SPFUS",
        "EP500-US-WH-BL-SPFUS",
        "2*EP500-US-WH-BL-SPFUS",
        "EP500+3*PV350-SPFUS",
        "EP500Pro-US-WH-BL-SPFUS",
        "2*EP500Pro-US-WH-BL-SPFUS",
        "EP500Pro+PV350*3-SPFUS",
        "AC300+B300-SPFUS",
        "AC300+B300+PV350-SPFUS",
        "AC300+B300+2*PV420-US-SPFUS",
        "AC300+B300+3*PV420-US-SPFUS",
        "2*AC300+2*B300-SPFUS",
        "EP800+2*B500-SPFUS",
        "EP800+3*B500-SPFUS",
        "EP800+4*B500-SPFUS",
        "B500-UN-WH-BL-SPFUS",
        "EP900+2*B500-SPFUS",
        "EP900+3*B500-SPFUS",
        "EP900+4*B500-SPFUS",
      ];
      // 更新affirm分期支付
      if (document.querySelector(".affirm-as-low-as") && list.includes(sku)) {
        document
          .querySelector(".affirm-as-low-as")
          .setAttribute("data-amount", currentVariant.price);
        document
          .querySelector(".affirm-as-low-as")
          .setAttribute("data-sku", sku);
        affirm.ui.refresh();
      }
      // 更新citi pay分期支付
      if (document.querySelector("#product-citi-pay")) {
        document
          .querySelector("#product-citi-pay")
          .setAttribute(
            "data-widget-item-price",
            (currentVariant.price / 100).toFixed(2)
          );
        document
          .querySelector("#product-citi-pay")
          .setAttribute("data-widget-item-sku", sku);
        ChargeAfter.promotions.update({});
      }
    }
    updateOptions() {
      const t = Array.from(this.querySelectorAll("[data-options]"));
      this.options = t.map(
        (t) =>
          Array.from(t.querySelectorAll("input")).find((t) => t.checked).value
      );
    }
    updateMasterId() {
      this.currentVariant = this.getVariantData().find(
        (t) => !t.options.map((t, e) => this.options[e] === t).includes(!1)
      );
    }
    updateMedia() {
      this.currentVariant &&
        this.currentVariant.featured_media &&
        this.main.thumbnailImageSlide(this.currentVariant.featured_media.id);
    }
    updateURL() {
      this.currentVariant &&  -1 !== location.pathname.indexOf("/products/") &&
        window.history.replaceState({}, "", this.dataset.url + "?variant=" + this.currentVariant.id);
      window.affirm && window.affirm.ui.refresh();
    }
    updateVariantInput() {
      document.querySelectorAll(`#product-form-${this.dataset.section},#product-form-installment`).forEach((t) => {
          const e = t.querySelector('input[name="id"]');
          (e.value = this.currentVariant.id),
            e.dispatchEvent(
              new Event("change", {
                bubbles: !0,
              })
            );
        });
    }
    async renderProductInfo() {
      const t = `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=` + this.dataset.section;
      const e = "price-" + this.dataset.section;
      const a = document.getElementById(e);

      // 切换变体修改优惠价格
      this.updateProductDiscounts(this.currentVariant.price);

      this.source = await fetch(t).then((t) => t.text()) .then((t) => new DOMParser().parseFromString(t, "text/html").getElementById(e));

 
      if (this.source && a) {
        a.innerHTML = this.source.innerHTML;
      }

      document.getElementById("price-" + this.dataset.section).classList.remove("visibility-hidden");
      this.toggleAddButton(
        !this.currentVariant.available,
        window.variantStrings.soldOut
      );

      // Update the price in the #swatch-buy component
      const swatchBuy = document.getElementById("swatch-buy");
      if (swatchBuy) {
        const priceElement = swatchBuy.querySelector(".text-wrapper-2.desc");
        if (priceElement) {
          // Format the price with commas
          const formattedPrice = (
            this.currentVariant.price / 100
          ).toLocaleString("en-US", { style: "currency", currency: "USD" });
          priceElement.textContent = formattedPrice;
        }
      }
    }
    
    toggleAddButton(t = !0, e, a) {    
      const r = document
          .getElementById("product-form-" + this.dataset.section)
          .querySelector('[name="add"]'),
        s = document
          .getElementById("product-form-" + this.dataset.section)
          .querySelector('[name="add"]')
          .querySelector("span");
      r &&
        (t
          ? (r.setAttribute("disabled", !0), e && (s.textContent = e))
          : (r.removeAttribute("disabled"),
          s.textContent = window.variantStrings.addToCart))

      if(this.main.querySelector(".tm-to-checkout")){
        const cr = document.getElementById("product-form-" + this.dataset.section).querySelector('.tm-to-checkout');
      cr && (t ? (cr.setAttribute("disabled", !0), e) : (cr.removeAttribute("disabled")));
      }
    }
    setUnavailable() {
      const t = document
          .getElementById("product-form-" + this.dataset.section)
          .querySelector('[name="add"]'),
        e = document
          .getElementById("product-form-" + this.dataset.section)
          .querySelector('[name="add"]')
          .querySelector("span");
      t &&
        ((e.textContent = window.variantStrings.unavailable),
        document
          .getElementById("price-" + this.dataset.section)
          .classList.add("uk-hidden"));
    }
    getVariantData() {
      return (
        (this.variantData =
          this.variantData ||
          JSON.parse(
            this.querySelector('[type="application/json"]').textContent
          )),
        this.variantData
      );
    }
    removeErrorMessage() {
      const t = this.closest("section");
      if (t) {
        const e = t.querySelector("product-form");
        e && e.handleErrorMessage();
      }
    }
    updateSelectInfo() {
      const t = window.Shopify || {},
        { id: e, price: a, title: r } = this.currentVariant;
      t.selected_variant = Object.assign(t.selected_variant || {}, {
        value: a / 100,
        content_ids: [e.toString()],
        content_name: r,
      });
    }

    updateCode() {
      let tm_discount = this.main.querySelector(".tm-discount-variant");
      let tm_discount_code = this.main.querySelector(".tm-discount-code");
      let tm_discount_date = this.main.querySelector(".tm-discount-date");
      let tm_discount_des = this.main.querySelector(".tm-discount-des");
      let tm_discount_coupon = this.main.querySelector(".tm-discount-coupon");
      const url = window.location.href;
      const { url: urlWithoutParams, paramValue } = this.parseUrl( url, "variant");
      fetch(`${urlWithoutParams}?view=json`)
        .then((response) => response.json())
        .then((responseData) => {
          // 在此处对 responseData 进行处理
          if (responseData && responseData.coupon != null) {
            let coupon = responseData.coupon;
            const foundObjs = coupon.filter((obj) => obj.hasOwnProperty(paramValue) );
            if (foundObjs.length <= 0 || tm_discount == null) return;

            if (foundObjs[0][paramValue] != null) {
              tm_discount.setAttribute("style", "display: block !important");
              tm_discount.dataset.discount = foundObjs[0][paramValue].code;
              tm_discount_code.innerHTML = foundObjs[0][paramValue].code;
              tm_discount_date.innerHTML =
                foundObjs[0][paramValue].start + "~" + foundObjs[0][paramValue].end;
              tm_discount_des.innerHTML = foundObjs[0][paramValue].des;
              tm_discount_coupon.innerHTML = foundObjs[0][paramValue].coupon;
            } else {
              tm_discount.setAttribute("style", "display: none !important");
            }
          } else {
            tm_discount.setAttribute("style", "display: none !important");
          }
        });
    }
    removeQueryParams(url) {
      const index = url.indexOf("?");
      if (index !== -1) {
        return url.substring(0, index);
      } else {
        return url;
      }
    }
    parseUrl(url, paramName) {
      const urlObj = new URL(url);
      const params = new URLSearchParams(urlObj.search);
      const paramValue = params.get(paramName);
      return {
        url: urlObj.origin + urlObj.pathname,
        paramValue: paramValue,
      };
    }
  }
  customElements.define("variant-radios", t);
  class e extends HTMLElement {
    constructor() {
      super(),
        (this.selectors = {
          slideshowElement: this.querySelector("[uk-slideshow]"),
          sliderElement: this.querySelector("[uk-slider]"),
        }),
        this.thumbnailImageClick();

        // 销售状态部分3
        window.ProductSalesStatus.init();
      //   const p = JSON.parse(this.dataset.product);
      // paypal.Messages({
      //   amount: p.price,
      //   style: {
      //     layout: "text",
      //     logo: {
      //       type: "primary"
      //     },
      //     text: {
      //       color: "black",
      //       size: 14
      //     }
      //   }
      // }).render('#is-paypal');
    }
    thumbnailImageClick() {
      var t = UIkit.util.queryAll("[uk-slider] [data-index]");
      UIkit.util.on(t, "click", (t) =>
        this.thumbnailImageSlide(t.target.dataset.thumbnailId)
      );
    }
    thumbnailImageSlide(t) {
      var e = this.querySelector(`[data-media-id="${t}"]`);
      e &&
        (UIkit.util.removeClass(
          UIkit.util.queryAll("[uk-slider] [data-thumbnail-id]"),
          "tm-active"
        ),
        this.querySelector(`[data-thumbnail-id="${t}"]`).classList.add(
          "tm-active"
        ),
        UIkit.slideshow(this.selectors.slideshowElement).show(
          e.dataset.imageIndex
        ),
        UIkit.slider(this.selectors.sliderElement).show(e.dataset.imageIndex));
    }
  }
  customElements.define("main-product", e);
  class a extends HTMLElement {
    constructor() {
      super(),
        (this.form = this.querySelector("form.main-product-form")),
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this)),
        (this.cartOffcanvas = document.querySelector("header-cart-dropdown"));

      // 直接跳转去购买
      this.querySelector(".tm-to-checkout").addEventListener("click", function (event) {
        var data = event.target.dataset;
        var quantity = document.querySelector("main-product").querySelector("quantity-input input").value || 1;
        var list = Array.from(event.target.attributes);
        var status = list.some((item) => item.name == "disabled");
        if(!status){
          window.location.href = data.link + "/cart/" + data.id + ":"+ Number(quantity);
        }  
      })
      
    }
    onSubmitHandler(t) {
      t.preventDefault(), this.handleErrorMessage();
      const e = this.querySelector('[type="submit"]'),
        a =
          (e.setAttribute("disabled", !0),
          e.classList.add("loading"),
          {
            method: "POST",
          });
      a.body = new FormData(this.form);
      try {
        // qp("track", "AddToCart");
        mkq("track", "AddToCart", shopify.selected_variant);
        gtag("event", "add_to_cart");
         Shopify.analytics.publish("custom_add_to_cart", { variant_id: this.form.querySelector('input[name="id"]').value });
        (rtbhEvents = window.rtbhEvents || []).push({
          eventType: "basketadd",
          offerId: this.closest("[data-main-product]").dataset.mainProduct,
        });
        
      } catch (t) {}
      fetch(routes.cart_add_url + ".js", a)
        .then((t) => t.json())
        .then(async (t) => {
          if (t.status) {
            this.handleErrorMessage(t.description);
          } else {
            var e = await this.getCartData();
            UIkit.offcanvas(this.cartOffcanvas).show();
            this.cartOffcanvas.renderContents(e);
            setTimeout(() => {
              affirm.ui.refresh();
            }, 300);
          }
        })
        .catch((t) => {
          console.error(t), UIkit.offcanvas(this.cartOffcanvas).hide();
        })
        .finally(() => {
          e.classList.remove("loading"), e.removeAttribute("disabled");
        });
    }
    handleErrorMessage(t = !1) {
      (this.errorMessageWrapper =
        this.errorMessageWrapper ||
        this.querySelector("[data-error-message-wrapper]") ||
        null),
        this.errorMessageWrapper &&
          ((this.errorMessage =
            this.errorMessage ||
            this.errorMessageWrapper.querySelector("[data-error-message]") ||
            null),
          this.errorMessageWrapper &&
            this.errorMessageWrapper.toggleAttribute("hidden", !t),
          t && this.errorMessage && (this.errorMessage.textContent = t));
    }
    async getCartData() {
      var t = JSON.stringify({
        sections: this.cartOffcanvas
          .getSectionsToRender()
          .map((t) => t.section),
        sections_url: window.location.pathname,
      });
      return fetch("" + routes.cart_update_url, {
        ...Shopify.fetchConfig(),
        body: t,
      })
        .then((t) => t.text())
        .then((t) => JSON.parse(t));
    }
  }
  customElements.define("product-form", a);

  // class productDiscounts extends HTMLElement {
  //   constructor() {
  //     super(),
  //       this.init()
  //   }
  //   init () {
  //   }
  // }
  // customElements.define("product-discounts", productDiscounts)
})();
